import { supportsNormalizedTemplate, PatternAreaType } from '../patterns/patternCoordinates';

export const resolveHeatmapDisplayMode = (rows: any[], areaType?: PatternAreaType | null): 'gps' | 'template' => {
    if (rows.some(row => row.mode === 'gps')) return 'gps';
    if (rows.some(row => row.mode === 'template')) return 'template';
    return supportsNormalizedTemplate(areaType) ? 'template' : 'gps';
};

// Static rows repeat the range count; animation frames count separately per bucket.
export const countUnplottedHeatmapSamples = (rows: any[]): number => {
    const byBucket = new Map<string, number>();
    rows.forEach(row => {
        const key = `${row.areaId ?? ''}:${row.bucket ?? row.timestamp ?? ''}`;
        byBucket.set(key, Math.max(byBucket.get(key) || 0, Number(row.unplottedPointCount) || 0));
    });
    return Array.from(byBucket.values()).reduce((a, b) => a + b, 0);
};
